import { useCallback, useMemo } from 'react';

export interface UseDateFormatProps extends Intl.DateTimeFormatOptions {
  locale?: string | string[];
}

export const useDateFormat = ({ locale = 'en-US', ...dateFormatOptions }: UseDateFormatProps) => {
  const dateFormat = useMemo(() => new Intl.DateTimeFormat(locale, dateFormatOptions), [locale, dateFormatOptions]);

  return useCallback((value: Date): string => dateFormat.format(value), [dateFormat]);
};
